module.exports = __webpack_public_path__ + "kibervarnost/img/tretje-pravilo.220534b2.jpg";